import { Injectable } from '@angular/core';
import { IFrameRequestHandlerI } from '@shared/services/integrations/iframe-request-handler.interface';
import { map, Observable, of } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { WebOnboardingService } from '@shared/services/web-onboarding/web-onboarding.service';
import { MainAppRoutesNames } from '@dta/ui/components/mainapp/resources/routes';
import { CONVERSATIONS_QUERY_PARAM_IDENTIFIER } from '@shared/modules/conversations/common/resources/conversation-query-param-identifier';
import { IFrameAppRequest, IFrameMethod } from '@intheloop/loop-integration';
import { UserAuthService } from '@shared/modules/auth/auth-data-access/user-auth.service';
import { ConversationView } from '@shared/modules/conversations/common/constants/conversation-view';
import { QUERY_PARAMETER_CONVERSATION_IDS } from '@shared/modules/conversations/common/constants/query-parameter-conversation-ids';
import { FILTER_ENUM_PREFIX } from '@shared/modules/shared-tag/common/helpers/shared-tag-folder-url';
import { FilterEnum } from '@shared/api/api-loop/models';
import { CONVERSATION_VIEW_ROUTE } from '@shared/modules/conversations/common/constants/conversation-view-route';

@Injectable()
export class AppHelper implements IFrameRequestHandlerI {
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _webOnBoardingService: WebOnboardingService,
    private userAuthService: UserAuthService
  ) {}

  handleRequest(request: IFrameAppRequest, integrationId: string): Observable<any> {
    switch (request.method) {
      case IFrameMethod.FILTER_BY_IDS_IN_CONTEXT:
        let param = Array.isArray(request.conversationIds) ? request.conversationIds.join(';') : [];
        if (this._router.url.includes(ConversationView.loopInbox) || this._router.url.includes('conversation')) {
          this._router.navigate([MainAppRoutesNames.conversations], {
            queryParams: {
              [CONVERSATIONS_QUERY_PARAM_IDENTIFIER]: param
            }
          });
        } else {
          const urlSegments = this._router.url.split('?')[0].split('/');
          const viewIndex = urlSegments.indexOf(CONVERSATION_VIEW_ROUTE);
          const channelId = viewIndex >= 0 ? urlSegments[viewIndex + 1] : null;
          if (channelId) {
            this._router.navigate(
              [`${CONVERSATION_VIEW_ROUTE}/${channelId}/${FILTER_ENUM_PREFIX}${FilterEnum.ALL_MESSAGES}`],
              {
                queryParams: { [QUERY_PARAMETER_CONVERSATION_IDS]: param }
              }
            );
          }
        }
        return of(undefined);
      case IFrameMethod.OPEN_WEB_ON_BOARDING:
        this._webOnBoardingService.openCustom(new URLSearchParams(), request.path, window.open());
        return of(undefined);
      case IFrameMethod.GET_WORKSPACE_ID:
        return this.userAuthService.currentSession$.pipe(map(session => session?.license?.id ?? null));
    }
  }
}
